<template>
  <el-container>
    <el-header class="order-layout">
      <Header title="订单详情" />
    </el-header>
    <el-main class="flex-column">
      <div class="order-confirm-main bg-tran">
        <router-link class="bra" :to="{ name: 'userwellcome' }"
          >个人中心</router-link
        >
        <i class="el-icon-arrow-right bra" />
        <router-link class="bra" :to="{ name: 'orders' }">我的订单</router-link>
        <i class="el-icon-arrow-right bra" />
        <strong class="bra">订单号:{{ info.OrderNo }}</strong>
      </div>
    </el-main>
    <el-main>
      <div class="order-confirm-main pd-10 bg-white">
        <div class="goods-info" v-if="!info">
          <h3>{{ showErrorMsg() }}</h3>
        </div>
        <div class="goods-info" v-else>
          <el-row type="flex" justify="space-between" align="middle">
            <h3 class="tit-title">订单状态</h3>
          </el-row>
          <el-descriptions class="order-stat-desc" :column="1" border>
            <el-descriptions-item label="订单号">{{ info.OrderNo }}</el-descriptions-item>
            <el-descriptions-item label="订单状态">
              <el-tag :type="statusTagType" style="font-size: 16px; font-weight: bold;">{{ info.StatusName }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="异常信息" v-if="info.ErrorMsg || info.EStatusName">
              <div class="order-error-box">
                <div class="error-label" v-if="info.ErrorMsg">
                  <i class="bi bi-exclamation-diamond-fill" />
                  <span>{{ info.ErrorMsg }}</span>
                </div>
                <div class="error-label" v-if="info.EStatusName">
                  <i class="bi bi-chat-right-dots" />
                  <span>{{ info.EStatusName }}</span>
                </div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-divider />
          <el-row type="flex" justify="space-between" align="middle">
            <h3 class="tit-title">订单金额</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            style="flex-wrap: wrap"
          >
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>其他费用</span>
                <b class="text-danger text-monery">{{ info.OtherPrice }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>优惠金额</span>
                <b class="text-danger text-monery">{{ info.PriceAgioed }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>订单总价</span>
                <b class="text-danger text-monery">{{ info.TotalPrice }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>修改差额</span>
                <b class="text-danger text-monery">{{ info.PhaseAmt }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>应付金额</span>
                <b class="text-danger text-monery">{{ info.OrderAmt }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>已付金额</span>
                <b class="text-danger text-monery">{{ info.ReceiveAmt }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>待付金额</span>
                <b class="text-danger text-monery">{{ info.PayAmt }}</b>
              </div>
            </el-col>
          </el-row>

          <el-divider />
          <el-row type="flex" justify="space-between" align="middle">
            <h3 class="tit-title">服务方案</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            style="flex-wrap: wrap"
          >
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>服务名称</span>
                <b>{{ info.ServeName || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>服务编号</span>
                <b>{{ info.ServeNo || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>服务需求</span>
                <b>{{ info.ServiceNeeds || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>检测资质</span>
                <b>{{ info.Qualification || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>检测周期</span>
                <b>{{ info.Cycle || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>接样实验室</span>
                <b>{{ info.LabName || "" }}</b>
              </div>
            </el-col>
            <el-col
              :span="24"
              class="info-pan-box"
              v-if="info.ServicePics && info.ServicePics.length"
            >
              <el-row
                type="flex"
                justify="flex-start"
                align="middle"
                style="flex-wrap: wrap"
              >
                <div
                  class="img-box"
                  v-for="(p, pidx) in info.ServicePics"
                  :key="'ServicePics-' + pidx"
                >
                  <img :src="getImgFullPath(p.url)" />
                </div>
              </el-row>
            </el-col>
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">委托单位</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            style="flex-wrap: wrap"
          >
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>委托单位名称</span>
                <b>{{ info.ProxyCustName || "" }}</b>
              </div>
            </el-col>
            <!-- <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>英文名称</span>
                <b>{{ info.ProxyCustNameEN || "" }}</b>
              </div>
            </el-col> -->
            <!-- <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>统一社会信用代码</span>
                <b>{{ info.UscCode || "" }}</b>
              </div>
            </el-col> -->
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>委托单位地址</span>
                <b>{{ info.ProxyAddress || "" }}</b>
              </div>
            </el-col>
            <!-- <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>英文地址</span>
                <b>{{ info.ProxyAddressEN || "" }}</b>
              </div>
            </el-col> -->
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">生产制造单位</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            style="flex-wrap: wrap"
          >
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>生产商名称</span>
                <b>{{ info.ProdCustName || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>生产商地址</span>
                <b>{{ info.ProdCustAddress || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>制造商名称</span>
                <b>{{ info.MakeName || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>制造商地址</span>
                <b>{{ info.MakeAddress || "" }}</b>
              </div>
            </el-col>
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">联系信息</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            style="flex-wrap: wrap"
          >
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>联系人</span>
                <b>{{ info.Linker || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box">
              <div class="info-pan">
                <span>联系电话</span>
                <b>{{ info.LinkerPhone || "" }}</b>
              </div>
            </el-col>
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">检测服务</h3>
          </el-row>
          <template v-for="(item, index) in info.Items">
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline send-sample-box"
              :key="'items-' + index"
            >
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>{{ index + 1 }}. 服务名称</span>
                  <b>{{ item.ItemName || "" }}</b>
                </div>
              </el-col>
              <el-col :span="16" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>检测标准</span>
                  <b>{{ item.StdName || "" }}</b>
                </div>
              </el-col>
            </el-row>
          </template>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">附加服务</h3>
          </el-row>
          <template v-for="(item, index) in info.OrderGoodsService">
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline send-sample-box"
              :key="'OrderGoodsService-' + index"
            >
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>{{ index + 1 }}. 服务名称</span>
                  <b>{{ item.ServeName || "" }}</b>
                </div>
              </el-col>

              <el-col :span="16" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>检测标准</span>
                  <b>{{ item.StdNames || "" }}</b>
                </div>
              </el-col>
              <el-col :span="2" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>数量</span>
                  <b>{{ item.Num || "" }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>标价类型</span>
                  <b>{{ item.PriceType === 1 ? "统一标价" : "区间标价" }} </b>
                </div>
              </el-col>
              <el-col :span="16" class="info-pan-box no-border">
                <span
                  id="item-price"
                  class="item-price item-price-2"
                  v-if="item.PriceType === 1"
                  >{{ item.ShopPrice }}</span
                >
                <template v-for="(sp, ii) in item.ShopSectionPrice" v-else>
                  <el-row
                    type="flex"
                    align="middle"
                    :key="'ShopSectionPrice-' + ii"
                  >
                    <span>数量</span>
                    <span class="item-price-type">{{
                      sp.s === 1 ? "第" : "每"
                    }}</span>
                    <b class="item-price-type">{{ sp.f }}-{{ sp.t }}</b>
                    <span>({{ sp.p > 0 ? "单价" : "总价" }})</span>
                    <span class="item-price item-price-2">{{
                      sp.p > 0 ? sp.p : sp.cp
                    }}</span>
                  </el-row>
                </template>
              </el-col>
            </el-row>
          </template>

          <template v-if="info.EGoodsService">
            <el-row
              type="flex"
              justify="space-between"
              align="middle"
              class="mg-t-20"
            >
              <h3 class="tit-title">附加服务【修改】</h3>
            </el-row>
            <template v-for="(item, index) in info.EGoodsService">
              <el-row
                type="flex"
                justify="start"
                align="middle"
                class="index-row no-underline send-sample-box"
                :key="'EGoodsService-' + index"
              >
                <el-col :span="8" class="info-pan-box no-border">
                  <div class="info-pan">
                    <span>{{ index + 1 }}. 服务名称</span>
                    <b>{{ item.ServeName || "" }}</b>
                  </div>
                </el-col>

                <el-col :span="14" class="info-pan-box no-border">
                  <div class="info-pan">
                    <span>检测标准</span>
                    <b>{{ item.StdName || "" }}</b>
                  </div>
                </el-col>
                <el-col :span="2" class="info-pan-box no-border">
                  <div class="info-pan">
                    <span>数量</span>
                    <b>{{ item.Num || "" }}</b>
                  </div>
                </el-col>
                <el-col :span="8" class="info-pan-box no-border">
                  <div class="info-pan">
                    <span>标价类型</span>
                    <b>{{ item.PriceType === 1 ? "统一标价" : "区间标价" }} </b>
                  </div>
                </el-col>
                <el-col :span="16" class="info-pan-box no-border">
                  <span
                    id="item-price"
                    class="item-price item-price-2"
                    v-if="item.PriceType === 1"
                    >{{ item.ShopPrice }}</span
                  >
                  <template v-for="(sp, ii) in item.ShopSectionPrice" v-else>
                    <el-row
                      type="flex"
                      align="middle"
                      :key="'ShopSectionPrice-' + ii"
                    >
                      <span>数量</span>
                      <span class="item-price-type">{{
                        sp.s === 1 ? "第" : "每"
                      }}</span>
                      <b class="item-price-type">{{ sp.f }}-{{ sp.t }}</b>
                      <span>({{ sp.p > 0 ? "单价" : "总价" }})</span>
                      <span class="item-price item-price-2">{{
                        sp.p > 0 ? sp.p : sp.cp
                      }}</span>
                    </el-row>
                  </template>
                </el-col>
              </el-row>
            </template>
          </template>
          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">其它服务</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            class="index-row no-underline"
          >
            <el-col :span="8" class="info-pan-box no-border">
              <div class="info-pan">
                <span>是否加急</span>
                <b style="font-size: 18px">{{
                  info.IsUrgent === 1 ? "☑" : "☐"
                }}</b>
                <strong class="item-price item-price-2">{{
                  info.UrgentPrice
                }}</strong>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box no-border">
              <div class="info-pan">
                <span>是否需要英语报告</span>
                <b style="font-size: 18px">{{
                  info.IsEnReport === 1 ? "☑" : "☐"
                }}</b>
                <strong class="item-price item-price-2">{{
                  info.CEnReportPrice
                }}</strong>
              </div>
            </el-col>
          </el-row>
          <template v-if="false">
            <el-row
              type="flex"
              justify="space-between"
              align="middle"
              class="mg-t-20"
            >
              <h3 class="tit-title">报告信息</h3>
            </el-row>
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline"
            >
              <el-col :span="8" class="info-pan-box no-border" v-if="false">
                <div class="info-pan">
                  <span>报告用途</span>
                  <b>{{ info.ReportUse || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>报告数量</span>
                  <b>{{ info.ReportNum || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>报告语言</span>
                  <b>{{ info.ReportLang || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>结论形式</span>
                  <b>{{ info.ReportConclusion || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>CQC申请号</span>
                  <b>{{ info.CQCNo || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>报告形式</span>
                  <b>{{ info.ReportForm || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>发放方式</span>
                  <b>{{ info.ReportSend || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>报告收取邮箱</span>
                  <b>{{ info.ReportEmail || "" }}</b>
                </div>
              </el-col>
              <el-col :span="8" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>报告邮寄地址</span>
                  <b>{{ info.ReportPostID || "" }}</b>
                </div>
              </el-col>
              <el-col :span="24" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>备注</span>
                  <b>{{ info.Remark || "" }}</b>
                </div>
              </el-col>
            </el-row>
          </template>
          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">报告文件</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            class="index-row no-underline"
          >
            <el-col
              :span="8"
              class="info-pan-box no-border"
              v-for="(f, i) in info.DemoReport"
              :key="'DemoReport-' + i"
            >
              <div class="info-pan">
                <el-link @click.stop.prevent="onFileClick(f.url)"
                  >[草稿报告]{{ f.name }}</el-link
                >
              </div>
            </el-col>
            <el-col
              :span="8"
              class="info-pan-box no-border"
              v-for="(f, i) in info.OfficialReport"
              :key="'OfficialReport-' + i"
            >
              <div class="info-pan">
                <el-link @click.stop.prevent="onFileClick(f.url)"
                  >[正式报告]{{ f.name }}</el-link
                >
              </div>
            </el-col>
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">订单附件</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            class="index-row no-underline"
          >
            <el-col
              :span="8"
              class="info-pan-box no-border"
              v-for="(f, fi) in info.OrderFile"
              :key="'OrderFile-' + fi"
            >
              <div class="info-pan">
                <el-link @click.stop.prevent="onFileClick(f.url)">{{
                  f.name
                }}</el-link>
              </div>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">样品信息</h3>
          </el-row>
          <el-row
            type="flex"
            justify="start"
            align="middle"
            class="index-row no-underline"
          >
            <el-col :span="8" class="info-pan-box no-border">
              <div class="info-pan">
                <span>CQC申请号</span>
                <b>{{ info.CQCNo || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box no-border">
              <div class="info-pan">
                <span>产品名称</span>
                <b>{{ info.SampleName || "" }}</b>
              </div>
            </el-col>
            <el-col :span="8" class="info-pan-box no-border">
              <div class="info-pan">
                <span>产品型号及参数</span>
                <b>{{ info.SampleModel || "" }}</b>
              </div>
            </el-col>
          </el-row>

          <div
            class="send-sample-box"
            v-for="(s, index) in orderSendSample"
            :key="'orderSendSample-' + index"
          >
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline"
            >
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>{{ index + 1 }}. 样品名称</span>
                  <b>{{ s.SampleName }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>样品数量</span>
                  <b>{{ s.SampleNum }}</b>
                </div>
              </el-col>
              <el-col
                :span="6"
                class="info-pan-box no-border"
                v-if="s.SendSampleType == 0"
              >
                <div class="info-pan">
                  <span>送样方式</span>
                  <b>客户自送</b>
                </div>
              </el-col>
              <el-col
                :span="6"
                class="info-pan-box no-border"
                v-if="s.SendSampleType == 1"
              >
                <div class="info-pan">
                  <span>快递公司</span>
                  <b>{{ s.SedDHL }}</b>
                </div>
              </el-col>
              <el-col
                :span="6"
                class="info-pan-box no-border"
                v-if="s.SendSampleType == 1"
              >
                <div class="info-pan">
                  <span>快递单号</span>
                  <b>{{ s.ExpressNum }}</b>
                </div>
              </el-col>

              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>实验室地址</span>
                  <b>{{ s.LabAddress }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>快递公司</span>
                  <b>{{ s.SedDHL }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>联系人</span>
                  <b>{{ s.LabLinker }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>电话</span>
                  <b>{{ s.LabLinkTel }}</b>
                </div>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline"
            >
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>样品处理方式</span>
                  <b>{{ s.SampleProcessing }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>到样状态</span>
                  <b>{{ s.ReceivedStatus }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>到样数量</span>
                  <b>{{ s.ReceivedNum }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>到样时间</span>
                  <b>{{ s.ReceivedTime }}</b>
                </div>
              </el-col>
              <el-col :span="24" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>到样备注</span>
                  <b>{{ s.ReceivedRemark }}</b>
                </div>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline"
            >
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>返样快递公司</span>
                  <b>{{ s.BackDHL }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>返样快递单号</span>
                  <b>{{ s.BackExpressNum }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>返样联系人</span>
                  <b>{{ s.BackLinker }}</b>
                </div>
              </el-col>
              <el-col :span="6" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>返样联系人电话</span>
                  <b>{{ s.BackLinkTel }}</b>
                </div>
              </el-col>
              <el-col :span="24" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>返样地址</span>
                  <b>{{ s.BackAddress }}</b>
                </div>
              </el-col>
            </el-row>
          </div>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">订单评价</h3>
          </el-row>
          <template v-for="(oe, oei) in orderEvaluate">
            <el-row
              type="flex"
              justify="start"
              align="middle"
              class="index-row no-underline"
              :key="'orderEvaluate' + oei"
            >
              <el-col :span="24" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>评价星级</span>
                  <b class="star-row">
                    <template v-for="i in 5">
                      <i
                        class="bi bi-star-fill"
                        :key="'star' + i"
                        :title="i + '星'"
                        v-if="oe.Star >= i"
                      />
                      <i
                        class="bi bi-star"
                        :key="'star-' + i"
                        :title="i + '星'"
                        v-else
                      />
                    </template>
                  </b>
                </div>
              </el-col>
              <el-col :span="24" class="info-pan-box no-border">
                <div class="info-pan">
                  <span>评价内容</span>
                  <b>{{ oe.Detail }}</b>
                </div>
              </el-col>
            </el-row>
          </template>

          <div class="top-line bg-white flex-fixed-bottom">
            <el-row
              type="flex"
              justify="space-between"
              align="middle"
              class="order-confirm-main"
            >
              <h3 class="item-price total-price">
                {{ info.TotalPrice || 0.0 }}
                <span v-if="info.PhaseAmt"
                  >{{ info.PhaseAmt >= 0 ? "+" : "-"
                  }}<span class="item-price">{{
                    Math.abs(info.PhaseAmt)
                  }}</span></span
                >
              </h3>
              <el-row type="flex" justify="start" align="middle">
                <div
                  v-if="info.Status >= 80 && orderEvaluate.length <= 0"
                  class="save-btn"
                  @click.stop="onOpenOrderEvaluateDialog(info)"
                >
                  <span style="margin-left: 5px">订单评价</span>
                </div>
                <div
                  v-if="info.Status < 69 && info.Status >= 0"
                  class="save-btn"
                  @click.stop="onOpenOrderFilesDialog(info)"
                >
                  <span style="margin-left: 5px">附件管理</span>
                </div>

                <div
                  v-if="info.Status <= 50 && info.Status >= 30"
                  class="save-btn"
                  @click.stop="onOpenOrderSampleEditDialog(info)"
                >
                  <span style="margin-left: 5px">录入样品</span>
                </div>
                <!-- <div
                  v-if="info.Status < 50 && info.Status >= 0"
                  class="danger-btn"
                  @click.stop.prevent="onChangeOrderStatus(-9)"
                >
                  <span style="margin-left: 5px">取消订单</span>
                </div> -->
                <div
                  v-if="info.Status === 0"
                  class="user-btn"
                  @click.stop.prevent="onChangeOrderStatus(11)"
                >
                  <span style="margin-left: 5px">提交订单</span>
                </div>
              </el-row>
            </el-row>
          </div>

          <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="mg-t-20"
          >
            <h3 class="tit-title">订单流程</h3>
          </el-row>
          <div class="info-pan tile-line">
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(activity, index) in info.OrderFlowLog"
                :key="index"
                :timestamp="activity.CreateTime"
                color="#03a9f4"
              >
                {{ activity.StatusMsg }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="order-layout">
      <Footer />
    </el-footer>

    <div v-if="enterpriseSelectorWndVisiable">
      <el-dialog
        title="选择认证企业"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="enterpriseSelectorWndVisiable"
        :show-close="true"
        :close-on-click-modal="false"
        width="800px"
        destroy-on-close
      >
        <el-table
          :data="enterprises"
          border
          ref="table"
          height="360"
          highlight-current-row
          @row-click="onEnterpriseTableRowClick"
          @row-dblclick="onEnterpriseTableRowDblClick"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            sortable
            width="250"
            show-overflow-tooltip
            prop="Name"
            label="企业名称"
          ></el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="Certificate"
            label="统一社会信用代码"
          ></el-table-column>
          <el-table-column
            min-width="180"
            sortable
            show-overflow-tooltip
            prop="Linker"
            label="联系人"
          ></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click="onEnterpriseSelect()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div v-if="addressSelectorWndVisiable">
      <el-dialog
        title="选择用户地址"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="addressSelectorWndVisiable"
        :show-close="true"
        :close-on-click-modal="false"
        width="800px"
        destroy-on-close
      >
        <el-table
          :data="userAddress"
          border
          ref="table"
          height="360"
          highlight-current-row
          @row-click="onAddressTableRowClick"
          @row-dblclick="onAddressTableRowDblClick"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="Linker"
            label="联系人"
          ></el-table-column>
          <el-table-column
            width="180"
            show-overflow-tooltip
            prop="CompanyName"
            label="单位名称"
          ></el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="LinkTel"
            label="联系人电话"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="180"
            prop="Address"
            label="详细地址"
          ></el-table-column>
          <el-table-column prop="IsDefault" label="默认地址">
            <template v-slot="scope">
              <i
                class="el-icon-check"
                v-if="scope.row.IsDefault.toString() === '1'"
              />
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click="onAddressSelect()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
import Header from "@/components/Head"
import Footer from "@/components/Food"
import {
  Add,
  GetOrderInfo,
  SaveGoodsOrder,
  GetList,
  SaveOrderStatus,
  GetItemDetailList,
  SaveOrderFile,
  RceivingSampleLabView,
  SubmitOrderEvaluate
} from "@/api/general-api"
import { getToken } from "@/utils/myAuth";
import OrderFiles from "@/components/OrderFiles"
import Vue from "vue"

const setps = [
  { active: 0, name: '提交订单', orderStatus: ['0'] },
  { active: 1, name: '信息确认', orderStatus: ['11', '19'] },
  //{ active: 2, name: '样品寄送', orderStatus: ['30'] },
  { active: 3, name: '样品检测', orderStatus: ['40'] },
  { active: 4, name: '完成检测', orderStatus: ['60'] },
  { active: 5, name: '报告发放', orderStatus: ['80'] },
  { active: 6, name: '已完成', orderStatus: ['90'] },
]
export default {
  name: 'OrderInfo',
  components: { Header, Footer },
  data() {
    return {
      setps,
      setpActive: 0,
      orderStatus: [],
      currentEnterprise: null,
      enterpriseSelectorWndVisiable: false,
      currentAddress: null,
      addressSelectorWndVisiable: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      userSelectData: {
        ID: null,
        IdNums: []
      },
      info: null,
      msg: "",
      proxyInfo: {
        ProxyCustName: null,
        ProxyCustNameEN: null,
        UscCode: null,
        ProxyAddress: null,
        ProxyAddressEN: null,
        MakeName: null,
        MakeAddress: null,
        ProdCustName: null,
        ProdCustAddress: null,
        Linker: null,
        LinkerPhone: null,
      },
      proxyInfoRule: {
        ProxyCustName: [
          { required: true, message: '请输入委托单位名称', trigger: 'change' }
        ],
        Linker: [
          { required: true, message: '请输入联系人', trigger: 'change' }
        ],
        LinkerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'change' }
        ],
      },
      reportInfo: {
        ReportUse: '',
        ReportNum: 1,
        ReportLang: '中文报告',
        ReportConclusion: '',
        CQCNo: '',
        ReportForm: '电子报告',
        ReportSend: '',
        ReportEmail: '',
        Remark: '',
        ReportPostID: ''
      },
      reportInfoRule: {
        ReportEmail: [
          { required: true, message: '请输入报告收取邮箱', trigger: 'change' }
        ],
        ReportPostID: [
          { required: true, message: '请输入报告邮寄地址', trigger: 'change' }
        ],
      },
      enterprises: [],
      userAddress: [],
      sampleProcessing: [],
      orderSendSample: [],
      orderEvaluate: []
    }
  },
  created() {
    this.info = {}
    this.scrollTop = document.body.scrollTop
  },
  beforeDestroy() {
    document.body.scrollTo(0, this.scrollTop)
  },
  computed: {
    statusTagType() {
      const status = this.info && this.info.Status
      if (status === 90) return 'success'
      if (status === 0 || status === 10) return 'warning'
      if (status < 0) return 'danger'
      return ''
    }
  },
  mounted() {
    document.body.scrollTo(0, 0)
    const id = this.$route.params.id || this.$route.query.id
    if (!id) {
      return this.$message.error('参数错误!');
    }
    const token = getToken();
    if (!token) {
      localStorage.setItem('frmUrl', window.location.href)
      return this.$router.push("/login");
    }
    GetItemDetailList({ ItemCode: 'OrderStatus' }).then(res => {
      if (!res.success) {
        return this.$message.error("订单状态数据获取失败：" + res.msg)
      }
      this.orderStatus = [...res.data.map(x => ({
        name: x.ItemValue,
        label: x.ItemName
      }))]
      this.handleGetOrderInfo(id)
    })

  },
  methods: {
    onFileClick(fileUrl) {
      const url = fileUrl.toUpperCase().startsWith('HTTP') ? fileUrl : process.env.VUE_APP_BASE_API + fileUrl
      const extension = fileUrl.split(".").pop().toUpperCase()
      if (extension === 'PDF') {
        window.open(url, '_blank')
      } else {
        const a = document.createElement('a')
        a.download = url
        a.href = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

    },
    // --打开订单评价窗口
    onOpenOrderEvaluateDialog(order) {
      const compEdit = {
        compPath: require('@/views/Order/components/OrderEvaluate.vue'),
        compRef: 'OrderEvaluateDlg',
        key: 'compEdit'
      }
      const dlgOptions = {
        dialog: {
          title: '订单评价',
          width: '800px'
        },
        okBtn: {
          text: '提  交'
        },
        cancleBtn: {
          show: false,
          text: '取  消'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compEdit).Open((dlg, close) => {
        const f = dlg.$refs.OrderEvaluateDlg[0]
        if (f) {
          let data = f.GetData()
          if (data) {
            data = {
              OrderID: order.ID,
              ...data
            }
            const postData = {
              ID: order.ID,
              data: JSON.stringify(data)
            }
            SubmitOrderEvaluate(postData).then(res => {
              if (!res.success) {
                return this.$message.error("订单评价提交失败：" + res.msg)
              }
              this.$message.success("订单评价提交成功")
              close()
              this.handleGetOrderInfo(order.ID)
            })
          }
        }
      })
    },
    async onOpenOrderSampleEditDialog(order) {
      const lab = await RceivingSampleLabView({ ID: order.LabID })
      if (!lab.success) { return this.$message.error('接样实验室信息获取失败：' + res.msg) }
      const compShow = {
        compPath: require('@/views/Order/components/ListShow.vue'),
        compProps: {
          list: [
            { prop: '订单编号', value: order.OrderNo },
            { prop: '机构名称', value: order.InstitutionName },
            { prop: '接样实验室', value: lab.data.Name },
            { prop: '寄样地址', value: lab.data.Address },
            { prop: '联系人', value: lab.data.Linker },
            { prop: '联系人电话', value: lab.data.LinkTel },
          ]
        },
        key: 'compShow'
      }
      const compEdit = {
        compPath: require('@/views/Order/components/SampleEditForm.vue'),
        compProps: {
          order
        },
        compRef: 'orderSampleEditDlg',
        key: 'compEdit'
      }
      const dlgOptions = {
        dialog: {
          title: '订单样品编辑',
          width: '900px'
        },
        okBtn: {
          text: '提  交'
        },
        cancleBtn: {
          show: false,
          text: '取  消'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compShow).Component(compEdit).Open((dlg, close) => {
        let f = null
        if (Array.isArray(dlg)) {
          f = (dlg.find(x => x.refKey === 'orderSampleEditDlg') || {}).refComp
        } else {
          f = dlg.$refs.orderSampleEditDlg[0]
        }

        if (f) {
          if (Array.isArray(f)) {
            f = f[0]
          }
          let data = f.GetData()
          if (data) {
            data = {
              OrderID: order.ID,
              OrderNo: order.OrderNo,
              GoodsDeptID: order.GoodsDeptID,
              LabID: lab.data.ID,
              LabName: lab.data.Name,
              LabAddress: lab.data.Address,
              LabLinker: lab.data.Linker,
              LabLinkTel: lab.data.LinkTel,
              ...data
            }
            const postData = {
              Name: 'OrderSendSample',
              data: JSON.stringify(data)
            }
            Add(postData).then(res => {
              if (!res.success) {
                return this.$message.error("样品信息添加失败：" + res.msg)
              }
              this.$message.success("样品信息添加成功")
              close()
              this.handleGetOrderInfo(order.ID)
            })
          }
        }
      })
    },
    onOpenOrderFilesDialog(order) {
      this.currentOrder = Object.assign({}, order)
      const files = this.currentOrder.OrderFile && Array.isArray(this.currentOrder.OrderFile) ? [...this.currentOrder.OrderFile] : []

      const GirConstructor = Vue.extend(OrderFiles);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options({ files, max: 8, acceptFileTypes: ['PDF'], readOnly: false });
      nodeObj.Open((files, close) => this.handlePostReportFiles(files, order, close));
    },
    handlePostReportFiles(files, order, close) {
      SaveOrderFile({ OrderID: order.ID, ID: order.ID, OrderFile: JSON.stringify(files) }).then(res => {
        if (!res.success) {
          return this.$message.error('保存订单附件失败：' + res.msg)
        }
        this.$message.success('订单附件保存成功！')
        this.handleGetOrderInfo(order.ID)
        if (typeof close === 'function') {
          close();
        }
      })
    },
    onChangeOrderStatus(Status) {
      SaveOrderStatus({ Status, ID: this.info.ID }).then(res => {
        if (!res.success) {
          return this.$message.error('操作失败：' + res.msg)
        }
        this.$message.success('操作成功!')
        this.handleGetOrderInfo(this.info.ID)
      })
    },
    handleGetOrderInfo(id) {
      GetOrderInfo(id).then(res => {
        console.log('GetOrderInfo', res)
        if (!res.success) {
          return this.$message.error("订单信息获取失败：" + res.msg)
        }

        this.info = res.data
        const t = setps.find(x => x.orderStatus.includes(res.data.Status.toString()))
        this.setpActive = t ? t.active : res.data.Status
        // --获取订单样品
        this.GetOrderSendSample()
        // --获取评价信息
        this.GetOrderEvaluate()
      })
    },
    onAddressTableRowDblClick(row) {
      this.currentAddress = row
      this.onAddressSelect()
    },
    onAddressTableRowClick(row) {
      this.currentAddress = row
    },
    onAddressSelect() {
      if (this.currentAddress) {
        this.reportInfo.ReportPostID = this.currentAddress.Address
      }

      this.currentAddress = null;
      this.addressSelectorWndVisiable = false;
    },
    onEnterpriseTableRowDblClick(row) {
      this.currentEnterprise = row
      this.onEnterpriseSelect()
    },
    onEnterpriseTableRowClick(row) {
      this.currentEnterprise = row
    },
    onEnterpriseSelect() {
      if (this.currentEnterprise) {
        this.proxyInfo.ProxyCustName = this.currentEnterprise.Name
        this.proxyInfo.UscCode = this.currentEnterprise.Certificate
        this.proxyInfo.Linker = this.currentEnterprise.Linker
        this.proxyInfo.LinkerPhone = this.currentEnterprise.LinkTel
        this.proxyInfo.ProxyAddress = this.currentEnterprise.Address
        this.proxyInfo.MakeAddress = this.currentEnterprise.Address
        this.proxyInfo.MakeName = this.currentEnterprise.Name
        this.proxyInfo.ProdCustName = this.currentEnterprise.Name
        this.proxyInfo.ProdCustAddress = this.currentEnterprise.Address
      }

      this.currentEnterprise = null;
      this.enterpriseSelectorWndVisiable = false;
    },
    onRefProxyInfo(name, address) {
      this.proxyInfo[name] = this.proxyInfo.ProxyCustName
      this.proxyInfo[address] = this.proxyInfo.ProxyAddress
    },
    // --确定提交订单
    onPostOrder(Status) {
      this.handlePostOrder(Status)
    },
    handlePostOrder(Status) {
      SaveGoodsOrder({
        ID: this.info.ID,
        IdNums: JSON.stringify(this.userSelectData.IdNums),
        OrderData: JSON.stringify({ ...this.info }),
        Status
      }).then(res => {
        if (res.success) {
          this.$router.push('/center/orders') //this.$router.push('/center/orders/' + Status)
        } else {
          this.$message.error('操作失败：' + res.msg)
        }
      })
    },
    GetOrderEvaluate() {
      const queryParam = {
        Name: 'OrderEvaluate',
        searchEntity: JSON.stringify([{
          sqlField: 'OrderID',
          pattern: 'Equal',
          value: this.info.ID,
        }]),
        currentPage: 1,
        pageSize: 999
      }
      GetList(queryParam).then(res => {
        if (res.success) {
          this.orderEvaluate = [...res.data.rows]
        }
      })
    },
    GetOrderSendSample() {
      const queryParam = {
        Name: 'OrderSendSample',
        searchEntity: JSON.stringify([{
          sqlField: 'OrderID',
          pattern: 'Equal',
          value: this.info.ID,
        }]),
        currentPage: 1,
        pageSize: 999
      }
      Promise.all([
        GetItemDetailList({ ItemCode: 'SampleProcessing' }),
        GetItemDetailList({ ItemCode: 'ReceivedStatus' }),
        GetList(queryParam)
      ]).then(resArr => {
        const [r1, r2, res] = resArr
        let SampleProcessing = [], ReceivedStatus = []
        if (r1.success) {
          SampleProcessing = [...r1.data]
        }
        if (r2.success) {
          ReceivedStatus = [...r2.data]
        }
        if (!res.success) {
          return this.$message.error('订单送样信息获取失败：' + res.msg)
        }

        this.orderSendSample = [...res.data.rows.map(x => {
          if (x.SampleProcessing) {
            let a = SampleProcessing.find(y => y.ItemValue === x.SampleProcessing.toString())
            x.SampleProcessing = a ? a.ItemName : x.SampleProcessing
          }
          if (x.ReceivedStatus) {
            let b = ReceivedStatus.find(y => y.ItemValue === x.ReceivedStatus.toString())
            x.ReceivedStatus = b ? b.ItemName : x.ReceivedStatus
          }
          return x;
        })]
      }).catch(e => {
        this.$message.error('订单送样信息获取失败：' + e.message)
      })
    },
    onSelectAddressClick() {
      const queryParam = {
        Name: 'UserAddress',
        searchEntity: JSON.stringify([]),
        currentPage: 1,
        pageSize: 999
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('用户地址列表获取失败：' + res.msg)
        }

        let userAddress = [...res.data.rows]
        if (!userAddress || !userAddress.length) {
          return this.$message.warning('用户地址列表为空！')
        }

        this.userAddress = userAddress;
        this.addressSelectorWndVisiable = true;
      })
    },
    onSelectCustClick() {
      const queryParam = {
        Name: 'UserAut',
        searchEntity: JSON.stringify([{
          sqlField: 'AutType',
          pattern: 'Equal',
          value: 2
        }]),
        currentPage: 1,
        pageSize: 999
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('企业认证列表获取失败：' + res.msg)
        }

        let enterprises = [...res.data.rows]
        if (!enterprises || !enterprises.length) {
          return this.$message.warning('企业认证列表为空！')
        }

        this.enterprises = enterprises;
        this.enterpriseSelectorWndVisiable = true;
      })
    },
    showErrorMsg() {
      if (!this.userSelectData.ID) {
        return '参数错误：缺少ID!'
      }
      return this.msg;
    },
    getImgFullPath(url) {
      return url.toUpperCase().startsWith("HTTP") ? url : this.baseUrl + url
    }
  }
}
</script>
<style lang="scss">
.order-confirm-main {
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #fff !important;
    outline: 0;
  }
  .el-button--default {
    margin-top: 1px !important;
    margin-left: 1px !important;
  }
  .el-button--default:focus,
  .el-button--default:hover {
    color: #083090 !important;
    border-color: #fff !important;
    background-color: #fff !important;
  }
}
.el-main {
  background-color: #f5f5f5 !important;
  padding: 0 !important;
}
.margin-top {
  margin-top: 5px;
  .el-descriptions-item__label {
    width: 140px !important;
  }

  &.spc-desc {
    .el-descriptions-item__label {
      width: 300px !important;
      padding-left: 20px !important;
    }
  }
  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 0px;
    border: 1px solid #fff;
    box-sizing: border-box;
    color: #083090;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #fff;
}
.el-select-dropdown__item.selected {
  color: #083090;
  font-weight: 700;
}
.star-row {
  padding: 10px;
  i {
    font-size: 18px;
    transition: all 0.3s linear;
    &.bi-star-fill {
      color: #c10015;
    }
    &.bi-star {
      color: #ccc;
    }
  }
}
.demo-ruleForm {
  .el-form-item {
    margin: 0;
    .el-input__inner {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 0px;
      border: 1px solid #fff;
      box-sizing: border-box;
      color: #083090;
      display: inline-block;
      font-size: inherit;
      height: 36px;
      line-height: 36px;
      outline: 0;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #fff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 0px solid #dcdfe6;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
      i {
        font-size: 18px;
        font-weight: bold;
        &.el-icon-question {
          color: #083090;
        }
      }
      &:hover {
        color: #083090 !important;
      }
    }
    .el-form-item__error {
      color: #c10015;
      font-size: 12px;
      line-height: 1;
      padding-top: 0px;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.bra {
  margin-right: 10px;
  font-size: 12px;
}
.div-v {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  a {
    font-size: 12px !important;
    &:hover {
      color: #083090;
    }
  }
}
.item-std-label {
  color: #083090;
  &::before {
    content: "✔";
  }
}
.item-price-label {
  color: #083090;
}
.required {
  &::after {
    content: "*";
    color: #c10015;
    font-size: 20px;
    font-weight: bold;
  }
}
.order-confirm-main {
  width: 1226px;
  margin: 0 auto;
  line-height: 42px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  .page-title {
    color: #ca4300;
  }
}
.order-layout {
  width: 100% !important;
  padding: 0 !important;
  height: auto !important;
}
.goods-info {
  background-color: #fff;
  padding: 0 20px;
  border: 1px solid #f5f5f5;
  .order-stat-box {
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid #f0f0f0;

    .info-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 12px;
      color: #6c6c6c;

      .stat-label {
        font-size: 32px;
        color: #083090;
      }
      .order-error-box {
        width: 100%;
        display: flex;
        justify-content: space-around;

        .error-label {
          color: #ca4300;
          font-size: 14px;
          line-height: 20px;
          padding: 5px;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border: 1px solid #f0f0f0;
          margin: 3px auto;
          i {
            font-size: 16px;
          }
          span {
            flex: 1;
            padding-left: 10px;
          }
        }
      }
    }
  }

  .setp-box {
    padding: 20px;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    .setp-divider {
      flex: 1;
      height: 16px;
      position: relative;
      border-bottom: 2px dashed #d1d1d1;
      i {
        position: absolute;
        right: -13px;
        bottom: -9px;
        font-size: 16px;
        font-weight: bold;
        color: #d1d1d1;
      }
      &:last-child {
        display: none;
      }

      &.text-desc {
        border-bottom: 2px dashed #d1d1d1;
        i {
          position: absolute;
          right: -13px;
          bottom: -9px;
          font-size: 16px;
          font-weight: bold;
          color: #d1d1d1;
        }
      }
      &.text-primary {
        border-bottom: 2px dashed #083090;
        i {
          position: absolute;
          right: -13px;
          bottom: -9px;
          font-size: 16px;
          font-weight: bold;
          color: #083090;
        }
      }
      &.text-success {
        border-bottom: 2px dashed #64b532;
        i {
          position: absolute;
          right: -13px;
          bottom: -9px;
          font-size: 16px;
          font-weight: bold;
          color: #64b532;
        }
      }
    }
    .setp-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 65px;

      i {
        font-size: 32px;
        box-sizing: border-box;
        width: 32px;
        height: 32px;
      }

      b {
        font-size: 12px;
        color: #6c6c6c;
      }
    }
  }
}
.img-box {
  width: 120px;
  height: 120px;
  padding: 5px;
  img {
    height: 100%;
  }
}
.index-row {
  flex-wrap: wrap;
  border-bottom: 1px dashed #f0f0f0;
  transition: all 0.3s linear;
  &:hover {
    border-bottom: 1px dashed #083090;
  }
  &.no-underline {
    border-bottom: 0px dashed #f0f0f0;
    &:hover {
      border-bottom: 0px dashed #083090;
    }
  }
}
.info-pan-box {
  padding: 0 10px;
  box-sizing: border-box;
  line-height: 24px;
  font-weight: 400;
  &.no-border {
    .info-pan {
      border-bottom: 0px dashed #f0f0f0;
      &:hover {
        border-bottom: 0px dashed #083090;
      }
    }
  }
  .info-pan {
    padding: 1px 5px;
    border-bottom: 0px dashed #f0f0f0;

    transition: all 0.3s linear;
    &:hover {
      border-bottom: 0px dashed #083090;
    }

    span {
      font-size: 12px;
      color: #888;
      &::after {
        content: ":";
        margin: 5px;
      }
    }

    b {
      font-size: 12px;
      font-weight: 450;
      color: #083090;
      padding: 0 5px;

      &.text-monery {
        font-weight: 600;
      }
    }
  }
}

.small-line {
  margin: 0px 10px;
  display: flex;
  align-items: center;
}

.small-title {
  color: #878787;
  font-size: 13px;
  min-width: 66px;
}

.small-text {
  font-size: 15px;
  color: #000;
  font-weight: bold;
}

.capability-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  line-height: 20px;
  padding: 10px 0;
  border-bottom: 1px dashed #f5f5f5;
  font-size: 14px;
}
.item-name {
  color: #083090;
}
.item-name b {
  width: 32px;
  text-align: center;
  margin-right: 5px;
}
.item-std {
  padding: 0 10px;
  color: #000;
  font-size: 12px;
}
.capability-item:last-child {
  border-bottom: 0px dashed #f5f5f5;
}

.capability-item .item-right {
  display: inline-block;
  font-size: 15px;
  width: 100px;
  color: #000;
  text-align: right;
}
.item-price {
  display: inline-block;
  color: #ca4300;
  font-size: 19px;
  font-weight: 600;
  width: 60px;

  &.total-price {
    width: 300px;
  }

  &.item-price-2,
  .item-price-2 {
    margin-left: 10px;
    display: inline-block;
    color: #ca4300;
    font-size: 14px;
    font-weight: 500;
    width: 60px;
  }

  .item-price-2 {
    &::before {
      color: #ca4300;
      content: "￥";
      font-size: 11px;
    }
  }
}

.capability-item .item-line {
  width: 100%;
  min-height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.capability-item .item-line-2 {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.item-price::before {
  color: #ca4300;
  content: "￥";
  font-size: 11px;
}
.item-line-2 > div {
  padding-top: 5px;
  padding-bottom: 5px;
}
.item-line-2 > div::before {
  content: "◉";
  padding-right: 5px;
  color: #666;
}
.item-price-type {
  padding: 0 5px;
  font-size: 14px;
  font-weight: 600;
  color: #083090;
}
.item-price-type::before {
  content: "【";
}
.item-price-type::after {
  content: "】";
}
.send-sample-box {
  border-radius: 5px;
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color: #f9f9f9;
}

.tile-line {
  padding-left:40px;
}
</style>